// Utils
import localStorageService from '../utils/services/localStorage/localStorage';

export const getIsElectron = () => process.env.APPLICATION_MODE === 'electron';
// TODO: Rename this to `getIsMobileHybrid` because it's used for Android as well.
export const getIsSwiftHybrid = () => process.env.APPLICATION_MODE === 'mobile-hybrid';
export const getIsHybridApp = () => getIsSwiftHybrid() || getIsElectron();

const HYBRID_USE_CASE_KEY = 'milanote.hybridUseCase';
export const getHybridUseCase = () => localStorageService.getItem(HYBRID_USE_CASE_KEY);
export const setHybridUseCase = (value) => localStorageService.setItem(HYBRID_USE_CASE_KEY, value);
